export default {
  // 已有文本
  'pages.dashboard.text':
    'Seamlessly integrates with store management ecosystem, providing remote point management solutions.',
  'pages.dashboard.storeTitle': 'Stores',
  'pages.dashboard.management.title': 'Head Office Management',

  // 二维码相关
  'pages.dashboard.tooltip.qrcode': 'Show Member Registration QR Code',
  'pages.dashboard.qrcode.title': 'Member Registration QR Code',
  'pages.dashboard.qrcode.download': 'Download QR Code',
  'pages.dashboard.qrcode.close': 'Close',

  // 其他已有文本
  'pages.dashboard.tooltip.members': 'Members',
  'pages.dashboard.tooltip.cards': 'Gift Cards',
  'pages.dashboard.tooltip.coupons': 'Vouchers',
  'pages.dashboard.tooltip.orders': 'Orders',

  'pages.dashboard.userApp.management.title': 'User App Management',
  'pages.dashboard.userApp.posters.button': 'Post Manager',
  'pages.dashboard.userApp.posters.title': 'Post Manager',
  'pages.dashboard.userApp.posters.add': 'Add Poster',
  'pages.dashboard.userApp.posters.edit': 'Edit Poster',
  'pages.dashboard.userApp.posters.noPermission.title': 'No Permission',
  'pages.dashboard.userApp.posters.noPermission.subTitle':
    'You do not have permission to access User App promotional poster management for this head office.',
  'pages.dashboard.userApp.posters.upload.imageTypeError':
    'Only jpg, png, or webp images can be uploaded',
  'pages.dashboard.userApp.posters.upload.sizeError': 'Image size cannot exceed 5MB',
  'pages.dashboard.userApp.posters.message.uploadRequired': 'Please upload a poster image',
  'pages.dashboard.userApp.posters.message.saveSuccess': 'Saved successfully',
  'pages.dashboard.userApp.posters.message.deleteSuccess': 'Deleted successfully',
  'pages.dashboard.userApp.posters.empty.all': 'No posters',
  'pages.dashboard.userApp.posters.empty.carousel': 'No top carousel posters',
  'pages.dashboard.userApp.posters.empty.static': 'No static posters',
  'pages.dashboard.userApp.posters.delete.confirm': 'Delete this poster?',
  'pages.dashboard.userApp.posters.delete.ok': 'Delete',
  'pages.dashboard.userApp.posters.delete.cancel': 'Cancel',
  'pages.dashboard.userApp.posters.type.carousel': 'Carousel Poster',
  'pages.dashboard.userApp.posters.type.static': 'Static Poster',
  'pages.dashboard.userApp.posters.sort': 'Sort',
  'pages.dashboard.userApp.posters.section.carousel': 'Top Carousel Posters',
  'pages.dashboard.userApp.posters.section.static': 'Static Posters',
  'pages.dashboard.userApp.posters.form.title': 'Poster Title',
  'pages.dashboard.userApp.posters.form.title.required': 'Please enter a poster title',
  'pages.dashboard.userApp.posters.form.title.placeholder': 'Example: Weekend Sale',
  'pages.dashboard.userApp.posters.form.displayType': 'Poster Type',
  'pages.dashboard.userApp.posters.form.displayType.required': 'Please select a poster type',
  'pages.dashboard.userApp.posters.form.displayType.carousel':
    'Carousel poster (top auto carousel, recommended 1536 x 860)',
  'pages.dashboard.userApp.posters.form.displayType.static':
    'Static poster (lower list, recommended 1536 x 560)',
  'pages.dashboard.userApp.posters.form.sortOrder': 'Carousel Order',
  'pages.dashboard.userApp.posters.form.sortOrder.required': 'Please select carousel order',
  'pages.dashboard.userApp.posters.form.sortOrder.page': 'Page {value}',
  'pages.dashboard.userApp.posters.form.image': 'Poster Image',
  'pages.dashboard.userApp.posters.form.image.replace': 'Replace Image (optional)',
  'pages.dashboard.userApp.posters.form.image.select': 'Select Image',
  'pages.dashboard.userApp.posters.scope.common': 'Common Posters',
  'pages.dashboard.userApp.posters.scope.store': 'Store Posters',
  'pages.dashboard.userApp.posters.store.placeholder': 'Select a Store',
  'pages.dashboard.userApp.posters.store.viewOnly':
    'View only — Store Poster management permission required',
  'pages.dashboard.userApp.catalog.tab': 'Catalog',
  'pages.dashboard.userApp.catalog.current': 'Current Catalog',
  'pages.dashboard.userApp.catalog.none': 'No Catalog published',
  'pages.dashboard.userApp.catalog.replace': 'Replace Catalog',
  'pages.dashboard.userApp.catalog.upload': 'Upload Catalog',
  'pages.dashboard.userApp.catalog.title': 'Title',
  'pages.dashboard.userApp.catalog.dates': 'Display period (Sydney time)',
  'pages.dashboard.userApp.catalog.pdf': 'PDF',
  'pages.dashboard.userApp.catalog.select': 'Select PDF',
  'pages.dashboard.userApp.catalog.entryImage': 'Catalog cover image',
  'pages.dashboard.userApp.catalog.entryImageHint': 'Recommended: 1200 × 360 px.',
  'pages.dashboard.userApp.catalog.selectImage': 'Select image',
  'pages.dashboard.userApp.catalog.invalidImage': 'Select a JPG, PNG or WebP image up to 20 MB',
  'pages.dashboard.userApp.catalog.publish': 'Publish Catalog',
  'pages.dashboard.userApp.catalog.replacePublish': 'Replace and publish',
  'pages.dashboard.userApp.catalog.delete': 'Delete',
  'pages.dashboard.userApp.catalog.confirm': 'Delete this Catalog?',
  'pages.dashboard.userApp.catalog.open': 'Open PDF',
  'pages.dashboard.userApp.catalog.pages': '{count} pages',
  'pages.dashboard.userApp.catalog.processing': 'Processing Catalog {done} / {total} pages',
  'pages.dashboard.userApp.catalog.failed': 'Processing failed: {error}',
  'pages.dashboard.userApp.catalog.issues': 'Scheduled Catalogs',
  'pages.dashboard.userApp.catalog.active': 'Live',
  'pages.dashboard.userApp.catalog.edit': 'Edit',
  'pages.dashboard.userApp.catalog.save': 'Save',
  'pages.dashboard.userApp.catalog.saved': 'Catalog saved',
  'pages.dashboard.userApp.catalog.removed': 'Catalog deleted',
  'pages.dashboard.userApp.catalog.queued': 'Catalog is processing',
  'pages.dashboard.userApp.catalog.required': 'Enter a title and select a PDF and cover image',
  'pages.dashboard.userApp.catalog.invalidPeriod': 'Select a valid start and end date and time',
  'pages.dashboard.userApp.catalog.invalidPdf': 'Select a PDF up to 30 MB',
  'pages.dashboard.userApp.catalog.loadFailed': 'Could not load Catalogs',
  'pages.dashboard.userApp.catalog.uploadFailed': 'Catalog upload failed',
  'pages.dashboard.userApp.catalog.saveFailed': 'Could not save Catalog',
  'pages.dashboard.userApp.catalog.removeFailed': 'Could not remove Catalog',
};
